// extracted by mini-css-extract-plugin
export default {"photoTitle":"photoTitle_IBnke","photoDescription":"photoDescription_5QM4c"};